import axios from 'axios';

export const baseURL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL, // Backend URL from environment variables
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true, // Add this if using cookies/credentials
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;